// @flow

import { Base, Placeholder, FqdnPlaceholder } from '@gandi/ui';

import styles from './PlaceholderRow.scss';

export function PlaceholderRow(): React.MixedElement {
  return (
    <Base backgroundColor="white" flex className={styles.root}>
      <Base flex flexGrow1 flexJustifyBetween>
        <FqdnPlaceholder />
      </Base>
      <Base flex flexJustifyEnd flexAlignItemsCenter gap="xsmall">
        <Placeholder chars={10} />
      </Base>
    </Base>
  );
}
